import React from 'react'
import PropTypes from 'prop-types'
import IconButton from '../IconButton'

function ClearInputButton({onPress}) {
  return (
    <div className="clearInputButton">
      <IconButton event={onPress} icon="close" />
    </div>
  )
}

ClearInputButton.propTypes = {
  onPress: PropTypes.func,
}

export default ClearInputButton
